{
  "napiersnik-rycerski": "armor/ubc/tunika-naramiennik-{g}.glb",
  "kolczuga-straznicy": "armor/ubc/tunika-naramiennik-{g}.glb",
  "brygantyna-herbowa": "armor/ubc/tunika-{g}.glb",
  "nagolenniki-plytowe": "armor/ubc/spodnie-{g}.glb",
  "nogawice-kolcze": "armor/ubc/spodnie-{g}.glb",
  "spodnie-herbowe": "armor/ubc/portki-{g}.glb",
  "rekawice-plytowe": "armor/ubc/karwasze-{g}.glb",
  "karwasze-straznika": "armor/ubc/karwasze-{g}.glb",
  "rekawice-kolcze": "armor/ubc/karwasze-{g}.glb",
  "trzewiki-plytowe": "armor/ubc/buty-{g}.glb",
  "buty-marszowe": "armor/ubc/buty-{g}.glb",
  "sabatony-herbowe": "armor/ubc/buty-{g}.glb",
  "kaftan-niedzwiedzi": "armor/ubc/koszula-{g}.glb",
  "uprzaz-wojownika": "armor/ubc/tunika-{g}.glb",
  "futro-watahy": "armor/ubc/koszula-{g}.glb",
  "futrzane-nogawice": "armor/ubc/portki-{g}.glb",
  "skorzane-portki": "armor/ubc/spodnie-{g}.glb",
  "przepaska-wodza": "armor/ubc/portki-{g}.glb",
  "owijki-piesci": "armor/ubc/rekawy-{g}.glb",
  "karwasze-z-kosci": "armor/ubc/karwasze-{g}.glb",
  "rekawice-futrzane": "armor/ubc/rekawy-{g}.glb",
  "futrzane-buty": "armor/ubc/trzewiki-{g}.glb",
  "sandaly-wedrowca": "armor/ubc/buty-{g}.glb",
  "okute-buciory": "armor/ubc/buty-{g}.glb",
  "szata-adepta": "armor/ubc/koszula-{g}.glb",
  "szata-gwiezdna": "armor/ubc/koszula-{g}.glb",
  "oponcza-zaru": "armor/ubc/koszula-{g}.glb",
  "spodnie-adepta": "armor/ubc/portki-{g}.glb",
  "szarawary-medrca": "armor/ubc/portki-{g}.glb",
  "nogawice-runiczne": "armor/ubc/portki-{g}.glb",
  "rekawiczki-zaklinacza": "armor/ubc/rekawy-{g}.glb",
  "karwasze-run": "armor/ubc/karwasze-{g}.glb",
  "mitenki-iskier": "armor/ubc/rekawy-{g}.glb",
  "miekkie-trzewiki": "armor/ubc/trzewiki-{g}.glb",
  "sandaly-pielgrzyma": "armor/ubc/buty-{g}.glb",
  "buty-mgly": "armor/ubc/trzewiki-{g}.glb",
  "kurta-zwiadowcy": "armor/ubc/tunika-{g}.glb",
  "kaftan-lowcy": "armor/ubc/tunika-{g}.glb",
  "pancerz-z-lusek": "armor/ubc/tunika-{g}.glb",
  "spodnie-tropiciela": "armor/ubc/spodnie-{g}.glb",
  "nogawice-z-latami": "armor/ubc/portki-{g}.glb",
  "ochraniacze-lowcy": "armor/ubc/spodnie-{g}.glb",
  "rekawice-lucznicze": "armor/ubc/karwasze-{g}.glb",
  "karwasze-strzelca": "armor/ubc/karwasze-{g}.glb",
  "rekawice-bez-palcow": "armor/ubc/karwasze-{g}.glb",
  "ciche-buty": "armor/ubc/buty-{g}.glb",
  "buty-bagienne": "armor/ubc/buty-{g}.glb",
  "wysokie-cholewy": "armor/ubc/buty-{g}.glb",
  "kaptur-zwiadowcy": "armor/ubc/kaptur-{g}.glb"
}
